var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotifications = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20 36.667c1.834 0 3.334-1.5 3.334-3.334h-6.667A3.332 3.332 0 0 0 20 36.667zm10-10v-8.334c0-5.116-2.733-9.4-7.5-10.533V6.667c0-1.384-1.116-2.5-2.5-2.5a2.496 2.496 0 0 0-2.5 2.5V7.8C12.717 8.933 10 13.2 10 18.333v8.334L6.667 30v1.667h26.667V30L30 26.667z"
})));
export default SvgNotifications;